<template>
  <div>
    <loading v-if="load" full="true" style="top: 32%"/>
    <div v-show="!load">
      <h6 class="mt-1 mb-4 text-center font-weight-bold">Respostas Rápidas</h6>
      <div v-if="replies.length">
        <a class="d-flex justify-content-between align-items-center text-dark text-decoration-none px-2 py-3 border-top" href="javascript:"
           v-for="(r) in replies" @click="$emit('response', r.response)">
          <div>
            <h6 class="font-weight-bold mb-0">{{r.name}}</h6>
            <div class="text-muted">
              {{r.response}}
            </div>
          </div>
          <i class="fa fa-angle-right text-muted"></i>
        </a>
      </div>
      <div class="border-top pt-3 text-center" v-else>
        <div class="alert alert-info small">
          Nenhuma resposta rápida configurada
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/loading";

export default {
  name: "ModalReplies",
  props: ['dados', 'session'],
  components: {Loading},
  data() {
    return {
      load: false
    }
  },

  methods: {
    getReplies() {
      this.load = true;
      this.$http.get('replies')
        .then(response => {
          this.load = false;
          this.$store.state.replies = (response.data || []);

        }, res => {
          this.load = false;
          console.log(res);
        });
    }
  },

  mounted() {
    if (!this.replies.length) {
      this.getReplies();
    }
  },

  computed: {
    replies() {
      return this.$store.state.replies || [];
    }
  }
}
</script>

<style scoped>
</style>
